"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineObject1 = void 0;
var InlineObject1 = (function () {
    function InlineObject1() {
    }
    InlineObject1.getAttributeTypeMap = function () {
        return InlineObject1.attributeTypeMap;
    };
    InlineObject1.discriminator = undefined;
    InlineObject1.attributeTypeMap = [
        {
            "name": "bankName",
            "baseName": "bank_name",
            "type": "string",
            "format": ""
        },
        {
            "name": "bankCode",
            "baseName": "bank_code",
            "type": "string",
            "format": ""
        },
        {
            "name": "branchName",
            "baseName": "branch_name",
            "type": "string",
            "format": ""
        },
        {
            "name": "branchCode",
            "baseName": "branch_code",
            "type": "string",
            "format": ""
        },
        {
            "name": "accountType",
            "baseName": "account_type",
            "type": "InlineObject1AccountTypeEnum",
            "format": ""
        },
        {
            "name": "accountNo",
            "baseName": "account_no",
            "type": "string",
            "format": ""
        },
        {
            "name": "accountName",
            "baseName": "account_name",
            "type": "string",
            "format": ""
        }
    ];
    return InlineObject1;
}());
exports.InlineObject1 = InlineObject1;
//# sourceMappingURL=InlineObject1.js.map